export default __webpack_public_path__ + "static/media/ListForYouInactive.0c282af9.svg";